import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../../../rootReducer';
import { AppDispatch } from '../../../../../store';
import Comments from './Comments';
import AddComment from './AddComment';
import { getAnnotationComments, addComment, deleteComment, editComment } from './AnnotationComments.slice';
import styles from '../AnnotationForm.module.scss';
import Busy from '../../../../Shared/Busy';
import { UseHaveAnyPermissions } from '../../../../../Auth/UseHaveAnyPermissions';
import { Permissions } from '../../../../../shared/models/permissions.enum';

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const CommentsTab: FC<Props> = ({
  isLoadingComments,
  comments,
  addedFailed,
  addedSuccessfully,
  onAddComment,
  onDeleteComment,
  onEditComment,
  onGetComments
}) => {
  const canAddComment = UseHaveAnyPermissions([Permissions.AnnotationManager_AddComments]);

  useEffect(() => {
    onGetComments();
  }, [onGetComments]);

  if (isLoadingComments) {
    return (
      <div className={styles.busyContainer}>
        <Busy />
      </div>
    );
  }

  return (
    <div>
      <AddComment
        disabled={!canAddComment}
        addedFailed={addedFailed}
        addedSuccessfully={addedSuccessfully}
        parentIds={[]}
        onCancelComment={() => {}}
        showCancel={false}
        onSaveComment={onAddComment}
      />
      <Comments
        addedFailed={addedFailed}
        addedSuccessfully={addedSuccessfully}
        parentIds={[]}
        comments={comments}
        onAddComment={onAddComment}
        onDeleteComment={onDeleteComment}
        onEditComment={onEditComment}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  isLoadingComments: state.annotationComments.isLoadingComments,
  comments: state.annotationComments.comments,
  addedFailed: state.annotationComments.addedFailed,
  addedSuccessfully: state.annotationComments.addedSuccessfully
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onGetComments: () => dispatch(getAnnotationComments()),
  onAddComment: (parentIds: string[], message: string) => dispatch(addComment(parentIds, message)),
  onDeleteComment: (parentIds: string[], id: string) => dispatch(deleteComment(parentIds, id)),
  onEditComment: (parentIds: string[], message: string, id: string) => dispatch(editComment(parentIds, message, id))
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentsTab);
